<template>
  <div id="landing-page-lembaga">
    <div class="content-lembaga-wrapper">
      <b-container class="breadcumb-wrapper">
        <p
          class="breadcumb-mitra"
          @click.prevent="moveToMitra"
        >Mitra</p>
        <img
          :src="arrowRight"
          alt="arrow-right"
          id="arrow-image"
        >
        <p class="breadcumb-lembaga">Lembaga</p>
      </b-container>

      <!-- background cover -->
      <div class="header-wrapper">
        <header-lembaga
          :imageBackground="institutionProfile.web_cover ? institutionProfile.web_cover : defaultHeader"
          :institutionProfile="institutionProfile"
          class="desktop"
        />
        <header-lembaga
          :imageBackground="institutionProfile.mobile_cover ? institutionProfile.mobile_cover : institutionProfile.web_cover ? institutionProfile.web_cover : defaultHeader"
          :institutionProfile="institutionProfile"
          class="mobile"
        />
      </div>

      <div class="mobile-logo-title-wrapper">
        <div class="mobile-content-logo-wrapper">
          <div class="mobile-logo-wrapper">
            <div class="mobile-logo-ellipse">
              <img
                :src="institutionProfile.logo ? institutionProfile.logo : defaultLogo"
                alt="logo-lembaga"
                id="logo-lembaga"
              >
            </div>
          </div>
          <div class="mobile-title-wrapper">
            <p class="mobile-title-value gotham-bold">{{institutionProfile.name}}</p>
          </div>
        </div>
      </div>

      <div class="mobile-description-wrapper">
        <div class="mobile-description-content-inside">
          <p
            class="mobile-description-value"
            v-html="sanitizeXSS(institutionProfile.profile)"
          ></p>
        </div>
      </div>

      <b-container class="description-wrapper">
        <div class="description-content-inside">
          <p
            class="description-value"
            v-html="sanitizeXSS(institutionProfile.profile)"
          ></p>
        </div>
      </b-container>
      <b-container class="menu-wrapper">
        <div class="label-menu">
          <p class="label-value gotham-book">Program yang dapat diikuti</p>
        </div>
        <div class="search-filter-menu">
          <div class="search-menu">
            <b-form @submit.prevent="fetchInstitutionProgram">
              <b-input-group>
                <b-form-input
                  class="input-search"
                  placeholder="Cari program belajar"
                  v-model="search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    class="button-search"
                    type="submit"
                  >
                    <font-awesome-icon
                      icon="search"
                      class="icon-search"
                    />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form>
          </div>
          <div class="filter-subject">
            <b-form-select
              class="dropdown-subject"
              v-model="customSubjectIndustry"
              :options="subjectIndustryList"
              value-field="id"
              text-field="name"
            >
            </b-form-select>
          </div>
          <div class="filter-menu">
            <b-form-select
              class="dropdown-jenjang"
              v-model="customYearLevel"
              :options="yearLevelList"
              value-field="key"
              text-field="name"
            >
            </b-form-select>
          </div>
        </div>
      </b-container>
      <div
        class="loading-wrapper"
        v-if="fetchStatus"
      >
        <template-loading />
      </div>
      <b-container
        class="menu-card-wrapper"
        v-else
      >
        <div
          v-if="programListEmpty"
          class="empty-wrapper"
        >
          <img
            :src="emptyState"
            alt="empty-image"
          >
          <p class="label-empty-image">Program tidak ditemukan, coba dengan filter lain.</p>
        </div>
        <div
          class="program-list-wrapper"
          v-else
        >
          <div class="desktop-card">
            <program-card
              v-for="data in programList"
              :programData="data"
              :key="data.id"
            />
          </div>
          <div class="mobile-card">
            <program-card-mobile
              v-for="data in programList"
              :programData="data"
              :key="data.id"
            />
          </div>
        </div>
      </b-container>
      <b-container
        class="load-more-wrapper"
        v-if="loadMoreStatus && !fetchStatus"
      >
        <b-button
          class="load-more-button"
          disabled
          v-if="loadMoreLoading"
        >
          <b-spinner
            small
            class="mr-2"
          ></b-spinner>Tampilkan Lainnya
        </b-button>
        <b-button
          class="load-more-button"
          v-else
          @click.prevent="fetchMoreProgram"
        >Tampilkan Lainnya</b-button>
      </b-container>
    </div>
  </div>
</template>

<script>

import Image from '@/assets/images/lembaga/index'
import HeaderLembaga from '@/components/lembaga/Header'
import ProgramCard from '@/components/programmu/ProgramCard'
import ProgramCardMobile from '@/components/programmu/ProgramCardMobile'
import TemplateLoading from '@/components/Table/TemplateLoading'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'PageLembaga',
  components: {
    HeaderLembaga,
    FontAwesomeIcon,
    ProgramCard,
    TemplateLoading,
    ProgramCardMobile
  },
  data: () => ({
    // asset data
    arrowRight: Image.arrow_right,
    defaultHeader: Image.default_header,
    defaultLogo: Image.default_logo,
    emptyState: Image.empty_program,
    // default state value
    yearLevelName: '',
    subjectIndustryName: '',
    search: '',
    programList: [],
    fetchStatus: false,
    // key for api
    yearLevelKey: '',
    subjectIndustryKey: '',
    baseYearLevelSlug: [
      { name: 'PAUD 0 - 6 Tahun', slug: 'paud' },
      { name: 'PAUD <1 Tahun', slug: 'paud0-1tahun' },
      { name: 'PAUD 1 & 2 tahun', slug: 'paud1-2tahun' },
      { name: 'PAUD 2 & 3 tahun', slug: 'paud2-3tahun' },
      { name: 'PAUD 3 & 4 tahun', slug: 'paud3-4tahun' },
      { name: 'PAUD TK A', slug: 'tk-a' },
      { name: 'PAUD TK B', slug: 'tk-b' },
      { name: 'SD/MI 7-12 tahun', slug: 'sd' },
      { name: 'Kelas 1 atau 7 tahun', slug: 'kelas1' },
      { name: 'Kelas 2 atau 8 tahun', slug: 'kelas2' },
      { name: 'Kelas 3 atau 9 tahun', slug: 'kelas3' },
      { name: 'Kelas 4 atau 10 tahun', slug: 'kelas4' },
      { name: 'Kelas 5 atau 11 tahun', slug: 'kelas5' },
      { name: 'Kelas 6 atau 12 tahun', slug: 'kelas6' },
      { name: 'SMP/MTs 13-15 tahun', slug: 'smp' },
      { name: 'Kelas 7 atau 13 tahun', slug: 'kelas7' },
      { name: 'Kelas 8 atau 14 tahun', slug: 'kelas8' },
      { name: 'Kelas 9 atau 15 tahun', slug: 'kelas9' },
      { name: 'SMA/SMK/MA 16-18 tahun', slug: 'sma' },
      { name: 'Kelas 10 atau 16 tahun', slug: 'kelas10' },
      { name: 'Kelas 11 atau 17 tahun', slug: 'kelas11' },
      { name: 'Kelas 12 atau 18 tahun', slug: 'kelas12' },
      { name: 'Mahasiswa', slug: 'mahasiswa' },
      { name: 'Profesional', slug: 'profesional' },
      { name: 'Profesional 1', slug: 'profesional1' },
      { name: 'Profesional 2', slug: 'profesional2' },
      { name: 'Profesional 3', slug: 'profesional3' },
      { name: 'Profesional 4', slug: 'profesional4' },
      { name: 'Orangtua', slug: 'orangtua' },
      { name: 'Guru', slug: 'guru' },
      { name: 'Guru 1', slug: 'guru1' },
      { name: 'Guru 2', slug: 'guru2' },
      { name: 'Guru 3', slug: 'guru3' },
      { name: 'Guru 4', slug: 'guru4' }
    ],
    // master list data
    subjectIndustryMaster: [],
    yearLevelMaster: [],
    // profile of institution
    institutionProfile: {},
    // dropdown data
    subjectIndustryList: [
      { name: 'Semua Bidang Studi/Industri', id: '' }
    ],
    yearLevelList: [
      { name: 'Semua Jenjang/Usia', key: '' }
    ],
    // load more process
    loadMoreStatus: false,
    loadMoreLoading: false
  }),
  computed: {
    currentLembagaRoute () {
      return this.$route.params.title
    },
    logo () {
      return {
        'background-image': `url(${this.defaultLogo})`
      }
    },
    programListEmpty () {
      if (this.programList.length === 0) {
        return true
      } else {
        return false
      }
    },
    customSubjectIndustry: {
      get () {
        return this.subjectIndustryKey
      },
      set (value) {
        const filteredSubjectIndustry = this.subjectIndustryList.find(item => item.id === value)
        this.subjectIndustryName = filteredSubjectIndustry.name
        this.subjectIndustryKey = value
        const yearLevelMaping = this.baseYearLevelSlug.find(item => item.name === this.yearLevelName)
        if (this.subjectIndustryKey && yearLevelMaping) {
          this.$router.push(`${this.$route.path}?bidang=${value}&jenjang=${yearLevelMaping.slug}`)
        } else if (this.subjectIndustryKey && !yearLevelMaping) {
          this.$router.push(`${this.$route.path}?bidang=${value}`)
        } else if (!this.subjectIndustryKey && yearLevelMaping) {
          this.$router.push(`${this.$route.path}?jenjang=${yearLevelMaping.slug}`)
        } else {
          this.$router.push(`${this.$route.path}`)
        }
        this.fetchInstitutionProgram()
      }
    },
    customYearLevel: {
      get () {
        return this.yearLevelKey
      },
      set (value) {
        const filteredYearLevel = this.yearLevelList.find(item => item.key === value)
        this.yearLevelName = filteredYearLevel.name ? filteredYearLevel.name : ''
        this.yearLevelKey = filteredYearLevel.key ? filteredYearLevel.key : ''
        const yearLevelMaping = this.baseYearLevelSlug.find(item => item.name === this.yearLevelName)
        const subjectIndustryMaping = this.subjectIndustryList.find(item => item.id === this.subjectIndustryKey)
        if (this.subjectIndustryKey && yearLevelMaping) {
          this.$router.push(`${this.$route.path}?bidang=${subjectIndustryMaping.id}&jenjang=${yearLevelMaping.slug}`)
        } else if (!this.subjectIndustryKey && yearLevelMaping) {
          this.$router.push(`${this.$route.path}?jenjang=${yearLevelMaping.slug}`)
        } else if (this.subjectIndustryKey && !yearLevelMaping) {
          this.$router.push(`${this.$route.path}?bidang=${subjectIndustryMaping.id}`)
        } else {
          this.$router.push(this.$route.path)
        }
        this.fetchInstitutionProgram()
      }
    }
  },
  methods: {
    sanitizeXSS (htmlEmbed) {
      return this.$XSSFilter(htmlEmbed)
    },
    // harus reference => dijadikan url
    mapingYearLevel (yearLevelQuery) {
      const yearLevel = this.baseYearLevelSlug.find(item => item.slug === yearLevelQuery)
      this.yearLevelName = yearLevel.name ? yearLevel.name : ''
      this.yearLevelKey = this.yearLevelName ? this.yearLevelName.replace('&', '').split(' ').join('').toLowerCase() : ''
      if (this.yearLevelList.length > 1) {
        const filteredYearLevel = this.yearLevelList.find(item => item.name === this.yearLevelName)
        this.yearLevelKey = filteredYearLevel ? filteredYearLevel.key : ''
      }
    },
    mapingSubjectIndustry (subjectIndustryQuery) {
      const subjectIndustry = this.subjectIndustryMaster.find(item => item.id === subjectIndustryQuery)
      this.subjectIndustryName = subjectIndustry ? subjectIndustry.name : ''
      this.subjectIndustryKey = subjectIndustry ? subjectIndustry.id : ''
    },
    async queryCheck () {
      const yearLevelQuery = this.$route.query.jenjang ? this.$route.query.jenjang : ''
      const subjectIndustryQuery = this.$route.query.bidang ? this.$route.query.bidang : ''

      if (yearLevelQuery && subjectIndustryQuery) {
        await this.mapingYearLevel(yearLevelQuery)
        await this.mapingSubjectIndustry(subjectIndustryQuery)
      } else if (yearLevelQuery && !subjectIndustryQuery) {
        await this.mapingYearLevel(yearLevelQuery)
        this.subjectIndustryKey = ''
        this.subjectIndustryName = ''
      } else if (!yearLevelQuery && subjectIndustryQuery) {
        await this.mapingSubjectIndustry(subjectIndustryQuery)
        this.yearLevelName = ''
        this.yearLevelKey = ''
      }

      this.fetchInstitutionProgram()
    },
    async fetchSubjectList () {
      const result = await this.$store.dispatch('institution/fetchSubjectList')
      if (result.status === 200 || result.message === 'OK') {
        this.subjectIndustryMaster = result.data
      }
    },
    moveToMitra () {
      this.$router.push('/mitra/all')
    },
    resetYearLevel () {
      this.yearLevelList = [
        { name: 'Tampilkan jenjang/usia', id: null, disabled: true }
      ]
    },
    async fetchYearLevel () {
      const result = await this.$store.dispatch('institution/fetchYearLevel')
      if (result.status === 200 || result.message === 'OK') {
        this.yearLevelMaster = result.data
      }
    },
    async initialFetchInstitutionProgram () {
      const payload = {
        page: 1,
        perPage: 30,
        slug: this.$route.params.institution_slug,
        search: this.search,
        year: this.yearLevelKey,
        subject: this.subjectIndustryKey ? this.subjectIndustryList.find(item => item.id === this.subjectIndustryKey).key : ''
      }
      const result = await this.$store.dispatch('institution/fetchInstitutionProgram', payload)
      if (result.status === 200 || result.message === 'OK') {
        this.programList = result.data
        this.yearLevelList = this.yearLevelList.concat(result.filter.year_level)
        this.subjectIndustryList = this.subjectIndustryList.concat(result.filter.subject)
        this.fetchStatus = false
      }
    },
    async fetchInstitutionProgram () {
      if (this.yearLevelList.length <= 1) {
        this.initialFetchInstitutionProgram()
      } else {
        const payload = {
          slug: this.$route.params.institution_slug,
          page: 1,
          perPage: 30,
          search: this.search,
          year: this.yearLevelKey,
          subject: this.subjectIndustryKey ? this.subjectIndustryList.find(item => item.id === this.subjectIndustryKey).key : ''
        }
        const result = await this.$store.dispatch('institution/fetchInstitutionProgram', payload)
        if (result.status === 200 || result.message === 'OK') {
          this.programList = result.data
          if (result['next-url']) {
            this.$store.commit('institution/CHANGE_NEXT_URL', result['next-url'])
            this.loadMoreStatus = true
          } else {
            this.loadMoreStatus = false
          }
        }
        this.fetchStatus = false
      }
    },
    async fetchMoreProgram () {
      if (this.yearLevelList.length <= 1) {
        this.initialFetchInstitutionProgram()
      } else {
        this.loadMoreLoading = true
        const result = await this.$store.dispatch('institution/loadMoreProgram')
        if (result.status === 200 || result.message === 'OK') {
          this.programList = this.programList.concat(result.data)
          if (result['next-url']) {
            this.$store.commit('institution/CHANGE_NEXT_URL', result['next-url'])
            this.loadMoreStatus = true
          } else {
            this.loadMoreStatus = false
          }
        }
      }
      this.loadMoreLoading = false
    },
    async fetchInstitutionProfile () {
      this.fetchStatus = true
      const slug = this.$route.params.institution_slug
      const payload = { slug }
      const result = await this.$store.dispatch('institution/fetchInstitutionProfile', payload)
      if (result.status === 200 || result.message === 'OK') {
        this.institutionProfile = result.data
      }
    }
  },
  watch: {
    search (value) {
      if (value === '') {
        this.fetchInstitutionProgram()
      }
    },
    async $route () {
      await this.initialFetchInstitutionProgram()
      await this.fetchInstitutionProfile()
      await this.fetchSubjectList()
      await this.fetchYearLevel()
      this.queryCheck()
    },
    institutionProfile (value) {
      if (Object.keys(value).length) {
        document.title = `Mitra ${this.institutionProfile.name} | Karier.mu`
      }
    }
  },
  async created () {
    await this.initialFetchInstitutionProgram()
    await this.fetchInstitutionProfile()
    await this.fetchSubjectList()
    await this.fetchYearLevel()
    this.queryCheck()
  }
}
</script>

<style scoped>
#landing-page-lembaga {
  min-height: 100vh;
}

p {
  margin-bottom: 0px;
}

.content-lembaga-wrapper {
  display: flex;
  flex-direction: column;
}

/* breadcumb style */

.breadcumb-wrapper {
  display: flex;
  align-items: center;
}

.breadcumb-mitra {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

#arrow-image {
  width: 6px;
  height: 8px;
  margin: 10px 10px;
  object-fit: contain;
}

.breadcumb-lembaga {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #3498db;
}

/* mobile logo and title style */
#logo-lembaga {
  width: 70%;
}

.mobile-logo-title-wrapper {
  display: none;
  width: 100%;
  margin-top: -70px;
}

.mobile-content-logo-wrapper {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
}

.mobile-logo-ellipse {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
}

.mobile-title-wrapper {
  margin: 25px 0px;
}

.mobile-title-value {
  font-size: 25px;
}

.mobile-description-wrapper {
  display: none;
  justify-content: center;
  padding: 0px 20px;
}

.mobile-description-value {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.7);
}

.description-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.description-content-inside {
  margin-left: 170px;
}

.description-value {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.7);
}

/* menu style */

.menu-wrapper {
  padding-top: 50px;
  display: flex;
  flex-direction: column;
}

.label-menu {
  display: flex;
}

.label-value {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  color: #1a2e5a;
}

/* filter menu */

.search-filter-menu {
  display: flex;
  margin-top: 20px;
}

.search-menu {
  margin-right: 5px;
  width: 250px;
}

.filter-subject {
  margin: 0px 5px;
  width: 250px;
}

.filter-menu {
  margin: 0px 5px;
  width: 250px;
}

.input-search {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  color: #1a2e5a;
  font-size: 15px;
}

.input-search:focus {
  outline-style: none;
  outline-color: #ffffff;
}

.input-search::placeholder {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  color: #bdbdbd;
}

.button-search {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  color: #1a2e5a;
  border-left-color: #ffffff;
  font-size: 15px;
}

.dropdown-subject {
  order: 1px solid #e0e0e0;
  box-sizing: border-box;
  border-radius: 17.5px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #4f4f4f;
}

.dropdown-jenjang {
  order: 1px solid #e0e0e0;
  box-sizing: border-box;
  border-radius: 17.5px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #4f4f4f;
}

.loading-wrapper {
  height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 70vh;
}

.label-empty-image {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  margin: 20px 0px;
}

/* program list style */

.program-list-wrapper {
  display: flex;
  justify-content: center;
  padding-bottom: 30px;
}

.desktop-card {
  display: flex;
  flex-wrap: wrap;
  margin: 50px 25px;
}

.mobile-card {
  display: none;
  flex-wrap: wrap;
  margin: 10px 0px;
  justify-content: center;
}

/* load more button */

.load-more-wrapper {
  display: flex;
  justify-content: center;
  margin: 0px auto 50px auto;
}

.load-more-button {
  background: #ffc429;
  border: 1px solid #ffc429;
  box-sizing: border-box;
  border-radius: 15px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  text-align: center;
  color: #ffffff;
}

.mobile{
  display: none;
}

@media screen and (max-width: 1200px) {
  .logo-title-wrapper {
    top: 26%;
    left: 10%;
  }

  .description-content-inside {
    width: 83%;
  }

  .search-menu {
    width: 100%;
  }

  .filter-subject {
    width: 100%;
    margin: 0px;
  }

  .filter-menu {
    width: 100%;
  }
}

@media screen and (max-width: 1100px) {
  .logo-title-wrapper {
    left: 8%;
    right: 15%;
  }

  .description-content-inside {
    width: 82%;
  }
}

@media screen and (max-width: 1024px) {
  .logo-title-wrapper {
    top: 24%;
    left: 4.5%;
    right: 15%;
  }

  .description-content-inside {
    width: 82%;
  }
}

@media screen and (max-width: 990px) {
  .logo-ellipse {
    width: 125px;
    height: 125px;
  }

  .logo-title-wrapper {
    top: 25%;
    left: 15%;
  }

  .description-content-inside {
    width: 80%;
  }

  .menu-wrapper {
    flex-direction: column;
    align-items: flex-start;
  }

  .search-filter-menu {
    margin: 10px 0px;
  }
}

@media screen and (max-width: 768px) {
  .logo-ellipse {
    width: 100px;
    height: 100px;
  }

  .logo-title-wrapper {
    top: 36%;
    left: 5%;
  }

  .description-content-inside {
    width: 82%;
  }

  .program-inside-wrapper {
    margin: 10px 0px;
  }
}

@media screen and (max-width: 425px) {
  .menu-card-wrapper {
    padding: 0px;
  }

  .mobile-logo-title-wrapper {
    display: flex;
  }

  .mobile-description-wrapper {
    display: flex;
  }

  .description-wrapper {
    display: none;
  }

  .menu-wrapper {
    flex-direction: column;
    width: 100%;
  }

  .search-filter-menu {
    flex-direction: column;
    width: 100%;
  }

  .search-menu {
    width: 100%;
    margin: 5px 0px;
  }

  .filter-menu {
    width: 100%;
    margin: 5px 0px;
  }

  .desktop-card {
    display: none;
  }

  .mobile-card {
    display: flex;
  }

  .mobile{
    display: inherit;
  }

  .desktop{
    display: none;
  }
}

@media screen and (max-width: 375px) {
  .label-value {
    font-size: 20px;
  }

  .mobile-title-value {
    padding: 0px 25px;
  }
}
</style>
